import { Classes } from '@blueprintjs/core'

const buildStateMap = (identifier, humanReadibleName, isActive, className, equivalents) => ({
  [identifier]: {
    id: identifier,
    humanReadableName: humanReadibleName,
    tagClassName: className,
    isActive,
    equivalents: equivalents ? [identifier, ...equivalents] : null
  }
})

export default {
  // Delist States
  ...buildStateMap('PENDING_DELISTING', 'Delisting', true, Classes.INTENT_WARNING, null),
  ...buildStateMap('DELISTING', 'Delisting', true, Classes.INTENT_WARNING, ['PENDING_DELISTING']),
  ...buildStateMap('DELISTED', 'Delisted', false, Classes.INTENT_PRIMARY, ['PURGED']),
  ...buildStateMap('DELISTING_FAILED', 'Delisting Failed', null, Classes.INTENT_DANGER, ['PURGING_FAILED']),

  // Expire States
  ...buildStateMap('EXPIRING', 'Expiring', true, Classes.INTENT_WARNING, []),
  ...buildStateMap('EXPIRED', 'Expired', false, Classes.INTENT_PRIMARY, []),
  ...buildStateMap('EXPIRING_FAILED', 'Expire Failed', null, Classes.INTENT_DANGER, []),

  // List States
  ...buildStateMap('LISTING', 'Listing', false, Classes.INTENT_WARNING, []),
  ...buildStateMap('LISTED', 'Listed', true, Classes.INTENT_SUCCESS, []),
  ...buildStateMap('LISTING_FAILED', 'Listing Failed', null, Classes.INTENT_DANGER, []),

  // Modify States
  ...buildStateMap('MODIFYING', 'Modifying', true, Classes.INTENT_WARNING, []),
  ...buildStateMap('MODIFY_FAILED', 'Modify Failed', true, Classes.INTENT_SUCCESS, []),

  // Purge States
  ...buildStateMap('PENDING_PURGING', 'Recycling', false, Classes.INTENT_WARNING, null),
  ...buildStateMap('PURGING', 'Recycling', false, Classes.INTENT_WARNING, ['PENDING_PURGING']),
  ...buildStateMap('PURGED', 'Recycled', false, Classes.INTENT_PRIMARY, []),
  ...buildStateMap('PURGING_FAILED', 'Recycling Failed', null, Classes.INTENT_DANGER, []),

  // Relist States
  ...buildStateMap('PENDING_RELISTING', 'Relisting', false, Classes.INTENT_WARNING, null),
  ...buildStateMap('RELISTING', 'Relisting', false, Classes.INTENT_WARNING, ['PENDING_RELISTING']),
  ...buildStateMap('RELISTING_FAILED', 'Relisting Failed', null, Classes.INTENT_DANGER, []),

  // Other States
  ...buildStateMap('PENDING', 'Pending', false, Classes.INTENT_WARNING, []),
  ...buildStateMap('MIXED', 'Mixed', true, Classes.INTENT_WARNING, []),
  ...buildStateMap('UNPAID', 'Unpaid', false, Classes.INTENT_WARNING, null),
  ...buildStateMap('SOLD', 'Sold', false, Classes.INTENT_SUCCESS, [])
}
